import { POD_NAMES, PRIORITIES, PRIORITY_CONFIG, PULSE_COLORS } from './pulseConfig.js'
import { podNameToKey } from './pulseHelpers.js'

function filterPods(byPod, selectedPod) {
    if (selectedPod === 'all') return byPod
    const podKey = podNameToKey(selectedPod)
    return podKey ? byPod.filter((p) => p.podKey === podKey) : byPod
}

export default function DefectMetrics({ total, byPriority, byPod, selectedPod, headerAction }) {
    const displayPods = filterPods(byPod, selectedPod)
    const displayTotal = selectedPod === 'all' ? total : displayPods.reduce((sum, p) => sum + p.total, 0)
    const displayByPriority =
        selectedPod === 'all'
            ? byPriority
            : PRIORITIES.reduce(
                  (acc, p) => {
                      acc[p] = displayPods.reduce((s, pod) => s + pod.priorities[p], 0)
                      return acc
                  },
                  { P0: 0, P1: 0, P2: 0, P3: 0 }
              )

    return (
        <div
            style={{
                background: PULSE_COLORS.cardBg,
                borderRadius: '12px',
                padding: '20px',
                border: `1px solid ${PULSE_COLORS.border}`,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    marginBottom: '16px',
                }}
            >
                <div>
                    <h3 style={{ color: PULSE_COLORS.text, fontWeight: 600, fontSize: '16px', margin: 0 }}>
                        Defect Metrics
                    </h3>
                    <p style={{ color: PULSE_COLORS.textMuted, fontSize: '13px', margin: '6px 0 0' }}>
                        Defect volume by priority and pod for the selected range.
                    </p>
                </div>
                {headerAction}
            </div>

            <div
                style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '24px',
                    marginBottom: '20px',
                    flexWrap: 'wrap',
                }}
            >
                {PRIORITIES.map((p) => {
                    const cfg = PRIORITY_CONFIG[p]
                    return (
                        <div key={p} style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '28px', fontWeight: 700, color: cfg.textColor }}>
                                {displayByPriority[p]}
                            </div>
                            <span
                                style={{
                                    display: 'inline-block',
                                    marginTop: '4px',
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    backgroundColor: cfg.color,
                                    color: cfg.textColor,
                                }}
                            >
                                {p}
                            </span>
                        </div>
                    )
                })}
                <div style={{ textAlign: 'center', marginLeft: 'auto' }}>
                    <div style={{ fontSize: '28px', fontWeight: 700, color: PULSE_COLORS.text }}>{displayTotal}</div>
                    <span
                        style={{
                            display: 'inline-block',
                            marginTop: '4px',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            fontSize: '11px',
                            fontWeight: 600,
                            backgroundColor: PULSE_COLORS.border,
                            color: PULSE_COLORS.textMuted,
                        }}
                    >
                        TOTAL
                    </span>
                </div>
            </div>

            {displayPods.length > 0 && (
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ borderBottom: `1px solid ${PULSE_COLORS.border}` }}>
                                <th
                                    style={{
                                        textAlign: 'left',
                                        padding: '8px 16px 8px 0',
                                        color: PULSE_COLORS.textMuted,
                                        fontWeight: 500,
                                    }}
                                >
                                    Pod
                                </th>
                                {PRIORITIES.map((p) => (
                                    <th
                                        key={p}
                                        style={{
                                            textAlign: 'center',
                                            padding: '8px 12px',
                                            fontWeight: 600,
                                            fontSize: '11px',
                                            color: PRIORITY_CONFIG[p].textColor,
                                        }}
                                    >
                                        {p}
                                    </th>
                                ))}
                                <th
                                    style={{
                                        textAlign: 'center',
                                        padding: '8px 12px',
                                        color: PULSE_COLORS.textMuted,
                                        fontWeight: 500,
                                        fontSize: '11px',
                                    }}
                                >
                                    Total
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayPods.map((pod) => (
                                <tr key={pod.podKey} style={{ borderBottom: `1px solid ${PULSE_COLORS.border}` }}>
                                    <td
                                        style={{ padding: '8px 16px 8px 0', color: PULSE_COLORS.text, fontWeight: 500 }}
                                    >
                                        {POD_NAMES[pod.podKey] ?? pod.podKey}
                                    </td>
                                    {PRIORITIES.map((p) => (
                                        <td key={p} style={{ textAlign: 'center', padding: '8px 12px' }}>
                                            <span
                                                style={{
                                                    fontWeight: 600,
                                                    color:
                                                        pod.priorities[p] > 0
                                                            ? PRIORITY_CONFIG[p].textColor
                                                            : PULSE_COLORS.textSubtle,
                                                }}
                                            >
                                                {pod.priorities[p]}
                                            </span>
                                        </td>
                                    ))}
                                    <td
                                        style={{
                                            textAlign: 'center',
                                            padding: '8px 12px',
                                            color: PULSE_COLORS.text,
                                            fontWeight: 600,
                                        }}
                                    >
                                        {pod.total}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    )
}
